import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';
import { COLORS } from '../theme';
import { LandingResult } from '../types';

interface TierStyle {
  color: number;
  peakAlpha: number;
  duration: number;
  ease: string;
  yoyo: boolean;
}

const STYLES: Record<LandingResult, TierStyle> = {
  perfect: { color: COLORS.yolk, peakAlpha: 0.55, duration: 280, ease: 'Cubic.Out', yoyo: true },
  good: { color: COLORS.emerald, peakAlpha: 0.32, duration: 240, ease: 'Cubic.Out', yoyo: true },
  just: { color: COLORS.cream, peakAlpha: 0.18, duration: 200, ease: 'Quad.Out', yoyo: true },
  miss: { color: COLORS.coral, peakAlpha: 0.4, duration: 160, ease: 'Quad.InOut', yoyo: true },
};

/** Fullscreen color flash overlay used to give each judgment tier its own
 * visual punch. Sits between the backdrop (depth 0) and the character (depth
 * 10) so it tints the scene without covering the cast. */
export class JudgmentFlash {
  private rect: Phaser.GameObjects.Rectangle;
  private activeTween: Phaser.Tweens.Tween | null = null;

  constructor(scene: Phaser.Scene) {
    this.rect = scene.add
      .rectangle(0, 0, GAME_CONFIG.STAGE_W, GAME_CONFIG.STAGE_H, COLORS.yolk, 0)
      .setOrigin(0, 0)
      .setDepth(1);
  }

  flash(tier: LandingResult) {
    const style = STYLES[tier];
    if (this.activeTween) {
      this.activeTween.stop();
      this.activeTween = null;
    }
    this.rect.setFillStyle(style.color);
    this.rect.setAlpha(0);
    this.activeTween = this.rect.scene.tweens.add({
      targets: this.rect,
      alpha: style.peakAlpha,
      duration: style.duration,
      ease: style.ease,
      yoyo: style.yoyo,
      onComplete: () => {
        this.rect.setAlpha(0);
        this.activeTween = null;
      },
    });
  }
}
